export default "__VITE_ASSET__DYOD5GZY__"